import SectionsListLayout from '../components/SectionsListLayout'

// TODO: Implement it - https://panowie.atlassian.net/browse/RG-248
const SectionsSetupListView = () => (
  <SectionsListLayout>Setup</SectionsListLayout>
)

export default SectionsSetupListView
